export const institucionales = [
  {
    desc: null,
    icon: 'newspaper',
    target: '_blank',
    title: 'Ofrecimientos Hs. y Cargos',
    url: 'https://educacion.sanjuan.edu.ar/mesj/LlamadosdePrensa/OfrecimientosdeHsC%C3%A1tedraCargosaCubrir.aspx',
    color: "#e84c3c"
  },
  {
    desc: null,
    icon: 'calendar_month',
    target: '_blank',
    title: 'Calendario Escolar',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Gobierno/CalendarioEscolar.aspx',//https://archivoseducacion.sanjuan.gob.ar/educacion/consultas.html?c=calendario
    color: "#e84c3c"
  },
  {
    desc: null,
    icon: 'menu_book',
    target: '_blank',
    title: 'Diseño Curricular',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Gobierno/Dise%C3%B1oCurricular.aspx?c=disenio',
    color: "#e84c3c"
  },
  {
    desc: null,
    icon: 'gavel',
    target: '_blank',
    title: 'Normas Legales',
    url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/estaticas/ME_NormasLegales.html', //https://archivoseducacion.sanjuan.gob.ar/educacion/consultas.html?c=normas',
    color: "#e84c3c"
  },
  {
    desc: null,
    icon: 'list_alt',
    target: '_blank',
    title: 'Formularios',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Gobierno/Formularios.aspx',
    color: "#e84c3c"
  },
  {
    desc: null,
    icon: 'groups',
    target: '_blank',
    title: 'Patrimonio',
    url: 'https://educacion.sanjuan.edu.ar/mesj/Gobierno/Patrimonio/DescargasdePlanillas.aspx?c=patrimonio',
    color: "#e84c3c"
  },
  {
    desc: null,
    icon: 'rate_review',
    target: '_blank',
    title: 'Capacitaciones SIGE',
    url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/consultas.html?c=sige',
    color: "#e84c3c"
  },
  /*{
    desc: null,
    icon: 'Send',
    target: '_blank',
    title: 'Programas Nacionales',
    url: '?uid=frame-https://archivoseducacion.sanjuan.gob.ar/educacion/consultas.html?c=programasnacionales',
    color: "#e84c3c"
  },*/
  {
    desc: null,
    icon: 'contacts',
    target: '_blank',
    title: 'Junta de Clasificación',
    url: 'https://archivoseducacion.sanjuan.gob.ar/educacion/consultas.html?c=juntas',
    color: "#e84c3c"
  },
]